<template>
  <!-- 远程教育 -->
  <div class="index-container">
    <div class="banner-box" :style="{ backgroundImage: 'url( ' + imgUrl + bannerInfo.banner + ')' }">
      <div class="start-box" @click="goPlayDetail(bannerInfo)">
        <i class="iconfont-icon icon-bofang2"></i>
      </div>
      <div class="start-button" @click="goPlayDetail(bannerInfo)">进入直播间</div>
    </div>
    <div class="course-container">
      <div class="condition-box">
        <div class="left-condition">
          <!-- <el-select class="c-list" v-model="couresType" placeholder="直播间名称">
            <el-option
              v-for="item in couresTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>-->
          <el-select @change="isFreeChange" class="c-list" v-model="isFree" placeholder="是否收费">
            <el-option
              v-for="item in isFreeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input v-model="keyWordSearch" placeholder="关键词搜索"></el-input>
          <div class="search-box" @click="searchKeyword">
            <i class="iconfont el-icon-search"></i>搜索
          </div>
          <div class="search-box reset-box" @click="reset">
            <i class="iconfont el-icon-refresh"></i>重置
          </div>
        </div>
        <div class="right-tab-box">
          <div
            class="r-tab"
            :class="tabIndex === index ? 'tab-active' : ''"
            v-for="(item, index) in tabList"
            :key="index"
            @click="tabSelect(item, index)"
          >{{ item }}</div>
        </div>
      </div>
      <div class="two-title">直播分类</div>
      <div class="keywords-box">
        <div
          class="k-list"
          :class="keywordsIndex === index ? 'k-active' : ''"
          v-for="(item,index) in keywordsList"
          :key="index"
          @click="keywordsSelect(item, index)"
        >{{item.title}}</div>
      </div>
      <!-- 课程列表 -->
      <div class="course-list-box" v-loading="loading">
        <div
          class="course-list"
          v-for="(item,index) in courseList"
          :key="index"
          @click="goPlayDetail(item)"
        >
          <div class="list-img" :style="{ backgroundImage: 'url( ' + imgUrl + item.cover + ')' }">
            <div
              class="list-status"
              :class="item.play_status === 1?'no-status':(item.play_status === 3?'over-status':'')"
            >
              <i
                class="iconfont-icon"
                :class="item.play_status === 1?'icon-weikaishi':(item.play_status === 3?'icon-jingshi1':'icon-ziyuanldpi')"
              ></i>
              {{item.play_status === 1?'未开始':(item.play_status === 2?'直播中':'已结束')}}
            </div>
          </div>
          <div class="right-content">
            <div class="list-type over-type" v-if="item.play_status === 3">已结束</div>
            <div class="list-type ing-type" v-else-if="item.play_status === 2">正在直播</div>
            <div class="list-type" v-else>开播时间：{{item.start_time}}</div>
            <div class="list-title">{{item.title}}</div>
            <div class="list-detail">{{item.detail}}</div>
            <!-- <div class="list-date"></div> -->
            <!-- {{item.create_time}} -->
            <div class="list-price">
              <div>
                <span>¥</span>
                {{item.price}}
                <!-- <span>.00</span> -->
              </div>
              <span class="list-sale">已有{{item.sales?item.sales:0}}人已购买</span>
            </div>
          </div>
        </div>
        <div class="no-data-box" v-if="courseList.length == 0">暂无数据</div>
      </div>

      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="8"
        :total="listTotal"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import bannerImg from '../components/bannerImg.vue';
import api from '../api/api';
import { imgUrl } from '../api/index';

export default {
  name: 'remoteEducation',
  components: {
    bannerImg
  },
  data() {
    return {
      imgUrl: imgUrl,
      bannerText: '远程教育',
      couresTypeList: [], // 课程分类
      couresType: '',
      tabList: ['全部', '未开始', '直播中', '已结束'],
      tabIndex: 0,
      keywordsList: [],
      keywordsIndex: '',
      isFree: '',
      isFreeList: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ],
      keyWordSearch: '',
      courseList: [],
      listTotal: 0,
      page: 1,
      cate_uuid: '',
      play_status: '',
      loading: true,
      bannerInfo: {}
    };
  },
  created() {
    this.getLiveList();
    this.getLiveType();
  },
  mounted() {
    scrollTo(0, 0);
  },
  methods: {
    // 重置
    reset() {
      this.page = 1;
      this.keyWordSearch = '';
      this.isFree = '';
      this.play_status = '';
      this.cate_uuid = '';
      this.tabIndex = 0;
      this.keywordsIndex = '';
      this.getLiveList();
    },
    // 关键词搜索
    searchKeyword() {
      this.getLiveList();
    },
    // 获取直播分类
    getLiveType() {
      api.getLiveType().then(res => {
        this.keywordsList = res.result;
      });
    },
    // 页码改变
    handleCurrentChange(val) {
      this.page = val;
      this.getLiveList();
    },
    // 是否收费
    isFreeChange(val) {
      this.isFree = val;
      this.getLiveList();
    },
    // 获取直播列表
    getLiveList() {
      this.loading = true;
      const params = {
        page_index: this.page,
        page_size: 8,
        keyword_search: this.keyWordSearch,
        is_charge: this.isFree,
        play_status: this.play_status,
        cate_uuid: this.cate_uuid
      };
      return api.getLiveList(params).then(result => {
        console.log(result);
        const res = result.result;
        this.courseList = res.result.data ? res.result.data : [];
        this.listTotal = res.result.total ? res.result.total : 1;
        this.bannerInfo = res.top ? res.top : '';
        this.loading = false;
      });
    },
    // 热门推荐 最新上线 学习次数选择
    tabSelect(item, index) {
      console.log(item, index);
      this.tabIndex = index;
      this.play_status = index;
      if (this.tabIndex === 0) {
        this.play_status = '';
      }
      this.getLiveList();
    },
    // 关键词选择
    keywordsSelect(item, index) {
      this.cate_uuid = item.uuid;
      this.keywordsIndex = index;
      this.getLiveList();
    },
    // 直播详情跳转
    goPlayDetail(item) {
      // const isLogin = localStorage.getItem('X-Access-Token');
      // console.log(isLogin);
      // if (!isLogin) {
      //   this.$message.warning('请登录！');
      //   location.reload();
      //   return;
      // }
      this.$router.push({
        path: '/playDetail',
        query: { uuid: item.uuid }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.banner-box {
  width: 100%;
  height: 780PX;
  padding-top: 284PX;
  text-align: center;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.start-box {
  width: 102PX;
  height: 102PX;
  margin: 0 auto 50PX;
  text-align: center;
  border: 6PX solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  .iconfont-icon {
    padding-left: 10PX;
    font-size: 50PX;
    color: #ffffff;
    line-height: 94PX;
  }
  &:hover {
    opacity: 0.8;
  }
}
.start-button {
  width: 288PX;
  height: 80PX;
  margin: 0 auto;
  font-size: 30PX;
  color: #ffffff;
  text-align: center;
  line-height: 80PX;
  background-color: #f1a373;
  border-radius: 6PX;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.course-container {
  width: 72%;
  margin: 0 auto;
}
.condition-box {
  display: flex;
  justify-content: space-between;
  padding: 50PX 0 40PX;
}
.left-condition {
  display: flex;
}
.search-box {
  width: 80PX;
  margin-right: 12PX;
  font-size: 14PX;
  color: #ffffff;
  text-align: center;
  line-height: 36PX;
  background-color: #f6ab2b;
  border: 1PX solid #f6ab2b;
  border-radius: 18PX;
  cursor: pointer;
  .iconfont {
    padding-right: 4PX;
  }
}
.reset-box {
  color: #f6ab2b;
  border: 1PX solid #f6ab2b;
  background-color: #ffffff;
}
/deep/ {
  .el-input--suffix .el-input__inner,
  .el-input,
  .el-input__inner {
    height: 38PX;
    line-height: 38PX;
    border-radius: 18PX;
  }
  .el-input {
    width: 154PX;
    margin-right: 28PX;
  }
}
.r-tab {
  width: 104PX;
  color: #333333;
  line-height: 36PX;
  text-align: center;
  border: 1PX solid #d6d6d6;
  cursor: pointer;
  &:first-child {
    border: 1PX solid #d6d6d6;
    border-right: none;
    border-top-left-radius: 18PX;
    border-bottom-left-radius: 18PX;
  }
  &:nth-child(2) {
    border-right: none;
  }
  &:last-child {
    border: 1PX solid #d6d6d6;
    border-left: none;
    border-top-right-radius: 18PX;
    border-bottom-right-radius: 18PX;
  }
  &:hover {
    color: #ffffff;
    border-color: #f6ab2b;
    background-color: #f6ab2b;
  }
}
.right-tab-box {
  display: flex;
  border-radius: 18PX;
  .tab-active {
    color: #ffffff;
    border-color: #f6ab2b;
    background-color: #f6ab2b;
  }
}
.two-title {
  padding-bottom: 18PX;
  font-size: 18PX;
  border-bottom: 1PX solid #ececec;
}
.keywords-box {
  display: flex;
  flex-wrap: wrap;
  padding: 28PX 0;
  border-bottom: 1PX solid #ededed;
  .k-list {
    padding: 0 24PX;
    margin: 0 20PX 12PX 0;
    color: #666666;
    line-height: 38PX;
    background: #fbfbfb;
    border-radius: 20PX;
    cursor: pointer;
    &:hover {
      color: #fb6d0a;
      background-color: #fef6e9;
    }
  }
  .k-active {
    color: #fb6d0a;
    background-color: #fef6e9;
  }
}
.course-list-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 48PX 0 130PX;
  .course-list {
    display: flex;
    width: calc((100% - 60PX) / 2);
    padding: 20PX 14PX 24PX 18PX;
    margin-bottom: 20PX;
    background: #ffffff;
    cursor: pointer;
    &:hover {
      box-shadow: 0PX 3PX 15PX 1PX rgba(200, 200, 200, 0.35);
      .list-title {
        color: #f6aa2b;
      }
    }
  }
  .list-img {
    flex-shrink: 0;
    width: 274PX;
    height: 208PX;
    background-color: #ececec;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .list-status {
    width: 80PX;
    height: 30PX;
    font-size: 12PX;
    color: #77e323;
    text-align: center;
    line-height: 30PX;
    background: rgba($color: #151515, $alpha: 0.4);
    border-radius: 0PX 0PX 19PX 0PX;
  }
  .no-status {
    color: #ffffff;
  }
  .over-status {
    color: #f91818;
  }
  .icon-weikaishi {
    position: relative;
    top: 2PX;
    color: #ffffff;
  }
  .icon-jingshi1 {
    color: #f91818;
  }
  .icon-ziyuanldpi {
    color: #77e323;
  }
  .right-content {
    // flex: 1;
    width: calc(100% - 300PX);
    padding: 10PX 0 10PX 22PX;
  }
  .list-type {
    display: inline-flex;
    padding: 2PX 8PX;
    font-size: 12PX;
    color: #eca021;
    background-color: rgba($color: #ffdca1, $alpha: 0.3);
    border-radius: 10PX;
  }
  .over-type {
    color: #b1b0ae;
    background-color: rgba($color: #b7b7b7, $alpha: 0.3);
  }
  .ing-type {
    color: #0fe21f;
    background-color: rgba($color: #20d220, $alpha: 0.1);
  }
  .list-title {
    padding: 14PX 0;
    font-size: 20PX;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .list-detail {
    min-height: 58PX;
    margin-bottom: 20PX;
    font-size: 12PX;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
  .list-date {
    display: inline-flex;
    padding: 0 12PX;
    margin-bottom: 16PX;
    font-size: 10PX;
    color: #ff7b1f;
    line-height: 24PX;
    background-color: #fdefe7;
    border-radius: 12PX;
  }
  .list-price {
    display: flex;
    justify-content: space-between;
    font-size: 26PX;
    color: #ec5d16;
    font-weight: bold;
    span {
      font-size: 14PX;
    }
    .list-sale {
      padding-left: 16PX;
      font-size: 12PX;
      color: #929292;
      font-weight: normal;
      line-height: 44PX;
    }
  }
}
/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination {
    margin-bottom: 80PX;
    text-align: center;
    button {
      width: 42PX;
      height: 42PX;
    }
  }
  .el-pager li {
    width: 42PX;
    height: 42PX;
    line-height: 42PX;
  }
}
@media screen and (max-width: 1600PX) {
  .course-container {
    width: 96%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/remoteEducation.vue